let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aIwZN")).then(() => parcelRequire('9ikUI'));